import ErrorResolver from './ErrorResolver';

export default ErrorResolver;
